import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import './style.scss';
import { Link } from 'react-router-dom';
import AuthLayout from '../../components/AuthLayout';
import { toast } from 'react-toastify';
import methodModel from '../../methods/methods';


const Forgotpassword = () => {
  const history = useNavigate();
  const formValidation = [{ key: 'email', email: true },
  ];

  const user = useSelector((state: any) => state.user)
  useEffect(() => {
    if (localStorage.getItem('CRA_auth_token')) {
      history('/dashboard')
    }
  }, [])

  const [form, setForm] = useState({ email: '' });

  useEffect(() => {

  }, [])

  const hendleSubmit = (e: any) => {
    e.preventDefault();
    let invalid = methodModel.getFormError(formValidation, form);
    if (invalid) {
      return toast.error('Please enter valid email address');
    }
    loader(true)

    ApiClient.post('admin/forgot/password', form).then(res => {
      if (res.success) {
        localStorage.setItem('ForgotEmail', form?.email)
        history('/resetpassword');
        setTimeout(() => {
          toast.success("We'll send you an email with verification code")
        }, 100);
      }
      loader(false)
    })
  };

  return (
    <>

      <AuthLayout>
        <form
          className="centerLogin"
          onSubmit={hendleSubmit}
        >
          <div className="text-center mb-4">
            <h3 className="text-left lgtext">Forgot Password</h3>
          </div>
          <p className='para_forget mb-3'>No worriest! Just enter your email and we are sending you code.</p>
          <div className="mb-3">
            <div className="inputWrapper">
              <input
                type="email"
                className="bg-white w-full h-10 flex items-center gap-2 overflow-hidden px-2  mb-0 w-full" placeholder='Email'
                value={form.email}
                required
                onChange={e => setForm({ ...form, email: e.target.value })}
              />

            </div>
          </div>


          <div className="buttons mt-5">

            <button type="submit" className="w-full text-white h-12 focus:ring-4 hover:shadow-lg focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium text-sm px-5 py-2.5 text-center loginclass hover:opacity-80 mb-4">
              Send Recovery Email
            </button>
          </div>

          <p className='accopuntt mt-0'> Just Remember?<Link className="sign_up text-[#A12238]" to="/login"> Sign In</Link></p>
        </form>
      </AuthLayout>


    </>
  );
};

export default Forgotpassword;
